export default "__VITE_ASSET__jkR$2z93__"